import { render, staticRenderFns } from "./tarffs.vue?vue&type=template&id=1a3de0cb&"
import script from "./tarffs.vue?vue&type=script&defer=true&lang=js&"
export * from "./tarffs.vue?vue&type=script&defer=true&lang=js&"
import style0 from "./tarffs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports